import React from 'react';

import { useImage } from 'common/hooks';
import { ICON } from 'resources/constants';
import { Wrapper, Title, SubHeader, Icon } from './elements';

type Props = {
  readonly className?: string;
  readonly children: string;
  readonly subheader: string;
  readonly imagePath?: string;
  readonly onClick?: () => void;
};

function Stat({
  className,
  children,
  subheader,
  imagePath,
  onClick,
}: Props): React.ReactElement {
  const [imageUrl] = useImage(imagePath);

  return (
    <Wrapper onClick={onClick} className={className} backgroundImage={imageUrl}>
      <Title>{children}</Title>
      <SubHeader>{subheader}</SubHeader>
      {onClick && <Icon color={'#fff'} icon={ICON.keyboardArrowRight} />}
    </Wrapper>
  );
}

export default Stat;
